import React, { useState, useEffect } from 'react'
import Form from "../../layouts/Form";
import { Grid, InputAdornment, makeStyles, ButtonGroup, Button as MuiButton } from '@material-ui/core';
import { Input, Select, Button } from "../../controls";
import ReplayIcon from '@material-ui/icons/Replay';
import PaidIcon from '@mui/icons-material/Paid';
import ReorderIcon from '@material-ui/icons/Reorder';
import { createAPIEndpoint, ENDPIONTS } from "../../api";
import { roundTo2DecimalPoint } from "../../utils";
import Popup from '../../layouts/Popup';
import Notification from "../../layouts/Notification";
import InputLabel from '@mui/material/InputLabel';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import DownloadIcon from '@mui/icons-material/Download';

const useStyles = makeStyles(theme => ({
    adornmentText: {
        '& .MuiTypography-root': {
            color: '#f3b33d',
            fontWeight: 'bolder',
            fontSize: '1.5em'
        }
    },
    submitButtonGroup: {
        backgroundColor: '#6666ff',
        color: theme.palette.common.white,
        margin: theme.spacing(1),
        '& .MuiButton-label': {
            textTransform: 'none'
        },
        '&:hover': {
            backgroundColor: '#f3b33d',
        }
    },
    formatoCelda: {
        backgroundColor: '#ff0000',
        color: '#ffffff',
        margin: theme.spacing(1),
        fontSize: '7'
    }
}))


const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: "#595959",
        color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 'small',

    },
}));



const getFreshModelObject2 = () => ({
    idusuario: 0,
    fecha: 'none',
    listaPagos: []

})

/*
function createData(name, calories, fat, carbs, protein) {
    return { name, calories, fat, carbs, protein };
}

const rows = [
    createData('Frozen yoghurt', 159, 6.0, 24, 4.0),
    createData('Ice cream sandwich', 237, 9.0, 37, 4.3),
    createData('Eclair', 262, 16.0, 24, 6.0),
    createData('Cupcake', 305, 3.7, 67, 4.3),
    createData('Gingerbread', 356, 16.0, 49, 3.9),
];
*/

export default function HistorialPago(props) {

    //console.log("---------***>" + JSON.stringify(props));

    const { values, setValues, errors, setErrors, handleInputChange, resetFormControls} = props;
    const classes = useStyles();

    const [pagoList, setPagoList] = useState([]);
    const [notify, setNotify] = useState({ isOpen: false });
    const [enviarpago, setEnviarpago] = useState(false);

    const [idusuario, setIdusuario] = useState(0);



    useEffect(() => {
        setIdusuario(parseInt(sessionStorage.getItem('idusuario')));


        //console.log("CARGA HISTORIAL PAGO ---> ");
        var f = new Date();
        var fecini = (f.getFullYear() + "-" + (f.getMonth() + 1) + "-" + f.getDate());
        var fecfin = (f.getFullYear() + "-" + (f.getMonth() + 1) + "-" + f.getDate());

        var parametros = "?idusuario=" + sessionStorage.getItem('idusuario') + "&fecini=" + fecini + "&fecfin=" + fecfin;

        createAPIEndpoint(ENDPIONTS.HISTORIAL_PAGOS).fetchHistory(parametros)
            .then(res => {
                let pagoList = res.data.map(item => ({
                    orderMasterId: item.orderMasterId,
                    orderNumber: item.orderNumber,
                    pmethod: item.pmethod,
                    alias: item.alias,
                    factura: item.factura,
                    gtotal: item.gtotal,
                    subtotal: item.subtotal,
                    valorIva: item.valorIva,
                    valorComision: item.valorComision,
                    ajuste: item.ajuste,
                    tipoajuste: item.tipoajuste,
                    motivoajuste: item.motivoajuste,
                    fecha: ((new Date(item.fecha)).getFullYear() + "/" + ((new Date(item.fecha)).getMonth() + 1)  + "/" + (new Date(item.fecha)).getDate() + " " + (new Date(item.fecha)).getHours() + ":" + (new Date(item.fecha)).getMinutes() ) ,
                    nombre: (item.idalumnoNavigation.nombres + " " + item.idalumnoNavigation.apellidopaterno + " " + item.idalumnoNavigation.apellidomaterno),
                    inconsistencia: item.inconsistencia
                }));

//                console.log(JSON.stringify(pagoList));


                setPagoList(pagoList);
            })
            .catch(err => console.log(err))
       

    }, [])


   
    /*
    useEffect(() => {
        if (orderId == 0) {
            //console.log("ingresar por order id");
            //resetFormControls();
        } else {
            createAPIEndpoint(ENDPIONTS.ORDER).fetchById(orderId)
                .then(res => {
                    setValues(res.data);
                    setErrors({});
                })
                .catch(err => console.log(err))
        }
    }, [orderId]);

    useEffect(() => {
        setValues({
            ...values,
            idalumno: alumnoid,
            idusuario: sessionStorage.getItem('idusuario'),
            alias: sessionStorage.getItem('alias'),
        })

    }, [alumnoid]);

    useEffect(() => {
        //console.log("---CCAAAA>" + correo2);

        setValues({
            ...values,
            correo: correo2
        })

    }, [correo2]);
    */

   



    

    const validateForm = () => {
        debugger;
        let temp = {};

        temp.factura = values.factura != "none" ? "" : "¡Este campo es obligatorio!";
        temp.customerId = values.customerId != 0 ? "" : "¡Este campo es obligatorio!";
        temp.pMethod = values.pMethod != "none" ? "" : "¡Este campo es obligatorio!";
        temp.orderDetails = values.orderDetails.length != 0 ? "" : "¡Este campo es obligatorio!";
        temp.iva = "";
        temp.comision = "";
        temp.rfc = "";
        temp.motivoajuste = "";
        temp.ajuste = "";
        temp.nivelsiguienteciclo = "";
        temp.gradosiguienteciclo = "";

        if (values.ajuste === "") {
            temp.ajuste = "¡El ajuste debe tener un valor mayor o igual a cero!";
        }


        //console.log("-----vamossss > " + parseFloat(values.ajuste));
        if (parseFloat(values.ajuste) > 0 && values.motivoajuste === "") {
            temp.motivoajuste = "¡Tienes un ajuste mayor a cero, por tanto debes ingresar el motivo de ajuste!";
        }

        if (values.factura == "SI") {
            if (values.rfc == "") {
                temp.rfc = "¡Este campo es obligatorio!";
            }

            if (values.iva == "none") {
                temp.iva = "¡Este campo es obligatorio!";
            }

        }


        if (values.pMethod == "Tarjeta Débito" || values.pMethod == "Tarjeta Crédito") {
            if (values.comision == "none") {
                temp.comision = "¡Este campo es obligatorio!";
            }


        }


        /*
        if (parseInt(values.customerId) === parseInt(cicloescolarsiguenteId)) {
            if (values.nivelsiguienteciclo == "none") {
                temp.nivelsiguienteciclo = "¡Este campo es obligatorio!";
            }
            if (values.gradosiguienteciclo == "none") {
                temp.gradosiguienteciclo = "¡Este campo es obligatorio!";
            }
        }
        */



        setErrors({ ...temp });
        return Object.values(temp).every(x => x === "");
    }

    


    const submitOrder = e => {
        e.preventDefault();


        if (validateForm()) {
            if (values.orderMasterId == 0) {

                //console.log("---AAAAA------***>" + JSON.stringify(values));


                setEnviarpago(true);
                createAPIEndpoint(ENDPIONTS.ORDER).create(values)
                    .then(res => {
                        //resetForm();
                        setNotify({ isOpen: true, message: '¡El pago ha sido realizado!' });
                        setEnviarpago(false);
                    })
                    .catch(err => console.log(err));

            } else {
                createAPIEndpoint(ENDPIONTS.ORDER).update(values.orderMasterId, values)
                    .then(res => {
                        //setOrderId(0);
                        setNotify({ isOpen: true, message: '¡El pago ha sido realizado!' });
                    })
                    .catch(err => console.log(err));
            }
        }

    }

    
    const bajarArchivo = id => {
        window.location.href = '/api/Alumno/BajarFormatoCobroAlumnoCarrito?id=' + id;
    }


    return (
        <>
            <br/>
            <Form onSubmit={submitOrder}>
                <Grid container spacing="40">

                    {
                        /*
                                             <Grid item xs={3}>
                        <Input
                            disabled
                            label="Número De Folio"
                            name="orderNumber"
                            value={values.orderNumber}
                            InputProps={{
                                startAdornment: <InputAdornment
                                    className={classes.adornmentText}
                                    position="start">#</InputAdornment>
                            }}
                        />

                    </Grid>

                    <Grid item xs={3}>

                        <Input
                            disabled
                            label="Total"
                            name="gTotal"
                            value={values.gTotal}
                            InputProps={{
                                startAdornment: <InputAdornment
                                    className={classes.adornmentText}
                                    position="start">$</InputAdornment>
                            }}
                        />

                    </Grid>

                         */
                    }



                    <Grid item xs={12}>
                        <TableContainer component={Paper}>
                            <Table sx={{ minWidth: 650 }} aria-label="simple table">
                                <TableHead>
                                    <TableRow>
                                        <StyledTableCell align="right">Alumno</StyledTableCell>
                                        <StyledTableCell align="right">Folio</StyledTableCell>
                                        <StyledTableCell align="right">Tipo Pago</StyledTableCell>
                                        <StyledTableCell align="right">Usuario</StyledTableCell>
                                        <StyledTableCell align="right">¿Facturado?</StyledTableCell>
                                        <StyledTableCell align="right">Total Pago</StyledTableCell>
                                        <StyledTableCell align="right">Subtotal</StyledTableCell>
                                        <StyledTableCell align="right">Iva</StyledTableCell>
                                        <StyledTableCell align="right">Comisión</StyledTableCell>
                                        <StyledTableCell align="right">Ajuste</StyledTableCell>
                                        <StyledTableCell align="right">Tipo Ajuste</StyledTableCell>
                                        <StyledTableCell align="right">Motivo Ajuste</StyledTableCell>
                                        <StyledTableCell align="right">Fecha</StyledTableCell>
                                        <StyledTableCell align="right">Bajar Recibo</StyledTableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {
                                        pagoList.map((row) => (
                                            <TableRow
                                                key={row.orderMasterId}
                                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                            >

                                                {
                                                    row.inconsistencia === 'SI' ?
                                                    (
                                                            <StyledTableCell align="center" className={classes.formatoCelda}>{row.nombre}</StyledTableCell>
                                                    ) :
                                                    (
                                                            <StyledTableCell align="center">{row.nombre}</StyledTableCell>
                                                    )
                                                }



                                                {
                                                    row.inconsistencia === 'SI' ?
                                                        (
                                                            <StyledTableCell align="center" className={classes.formatoCelda}>{row.orderNumber}</StyledTableCell>
                                                        ) :
                                                        (
                                                            <StyledTableCell align="center">{row.orderNumber}</StyledTableCell>
                                                        )
                                                }

                                                
                                                {
                                                    row.inconsistencia === 'SI' ?
                                                        (
                                                            <StyledTableCell align="center" className={classes.formatoCelda}>{row.pmethod}</StyledTableCell>
                                                        ) :
                                                        (
                                                            <StyledTableCell align="center">{row.pmethod}</StyledTableCell>
                                                        )
                                                }

                                                
                                                {
                                                    row.inconsistencia === 'SI' ?
                                                        (
                                                            <StyledTableCell align="center" className={classes.formatoCelda}>{row.alias}</StyledTableCell>
                                                        ) :
                                                        (
                                                            <StyledTableCell align="center">{row.alias}</StyledTableCell>
                                                        )
                                                }
                                                
                                                {
                                                    row.inconsistencia === 'SI' ?
                                                        (
                                                            <StyledTableCell align="center" className={classes.formatoCelda}>{row.factura}</StyledTableCell>
                                                        ) :
                                                        (
                                                            <StyledTableCell align="center">{row.factura}</StyledTableCell>
                                                        )
                                                }
                                                
                                                {
                                                    row.inconsistencia === 'SI' ?
                                                        (
                                                            <StyledTableCell align="center" className={classes.formatoCelda}>{row.gtotal}</StyledTableCell>
                                                        ) :
                                                        (
                                                            <StyledTableCell align="center">{row.gtotal}</StyledTableCell>
                                                        )
                                                }
                                                
                                                {
                                                    row.inconsistencia === 'SI' ?
                                                        (
                                                            <StyledTableCell align="center" className={classes.formatoCelda}>{row.subtotal}</StyledTableCell>
                                                        ) :
                                                        (
                                                            <StyledTableCell align="center">{row.subtotal}</StyledTableCell>
                                                        )
                                                }
                                                
                                                {
                                                    row.inconsistencia === 'SI' ?
                                                        (
                                                            <StyledTableCell align="center" className={classes.formatoCelda}>{row.valorIva}</StyledTableCell>
                                                        ) :
                                                        (
                                                            <StyledTableCell align="center">{row.valorIva}</StyledTableCell>
                                                        )
                                                }
                                                
                                                {
                                                    row.inconsistencia === 'SI' ?
                                                        (
                                                            <StyledTableCell align="center" className={classes.formatoCelda}>{row.valorComision}</StyledTableCell>
                                                        ) :
                                                        (
                                                            <StyledTableCell align="center">{row.valorComision}</StyledTableCell>
                                                        )
                                                }
                                                
                                                {
                                                    row.inconsistencia === 'SI' ?
                                                        (
                                                            <StyledTableCell align="center" className={classes.formatoCelda}>{row.ajuste}</StyledTableCell>
                                                        ) :
                                                        (
                                                            <StyledTableCell align="center">{row.ajuste}</StyledTableCell>
                                                        )
                                                }
                                                
                                                {
                                                    row.inconsistencia === 'SI' ?
                                                        (
                                                            <StyledTableCell align="center" className={classes.formatoCelda}>{row.tipoajuste}</StyledTableCell>
                                                        ) :
                                                        (
                                                            <StyledTableCell align="center">{row.tipoajuste}</StyledTableCell>
                                                        )
                                                }
                                                
                                                {
                                                    row.inconsistencia === 'SI' ?
                                                        (
                                                            <StyledTableCell align="center" className={classes.formatoCelda}>{row.motivoajuste}</StyledTableCell>
                                                        ) :
                                                        (
                                                            <StyledTableCell align="center">{row.motivoajuste}</StyledTableCell>
                                                        )
                                                }

                                                
                                                {
                                                    row.inconsistencia === 'SI' ?
                                                        (
                                                            <StyledTableCell align="center" className={classes.formatoCelda}>{row.fecha}</StyledTableCell>
                                                        ) :
                                                        (
                                                            <StyledTableCell align="center">{row.fecha}</StyledTableCell>
                                                        )
                                                }

                                                
                                                {
                                                    row.inconsistencia === 'SI' ?
                                                        (
                                                            <StyledTableCell align="center" className={classes.formatoCelda}><a onClick={() => bajarArchivo(row.orderMasterId)}><DownloadIcon color="primary" /></a></StyledTableCell>
                                                        ) :
                                                        (
                                                            <StyledTableCell align="center"><a onClick={() => bajarArchivo(row.orderMasterId)}><DownloadIcon color="primary" /></a></StyledTableCell>
                                                        )
                                                }
                                                

                                            </TableRow>
                                        ))
                                    }
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Grid>


                </Grid>
            </Form>
            
            <Notification {...{ notify, setNotify }} />
        </>
    )
}
